"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Predators = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var ResourceType_1 = require("../../ResourceType");
var CardName_1 = require("../../CardName");
var AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
var RemoveResourcesFromCard_1 = require("../../deferredActions/RemoveResourcesFromCard");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
var Predators = (function (_super) {
    __extends(Predators, _super);
    function Predators() {
        var _this = _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.PREDATORS,
            tags: [Tags_1.Tags.ANIMAL],
            cost: 14,
            resourceType: ResourceType_1.ResourceType.ANIMAL,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oxygen(11); }),
            metadata: {
                cardNumber: '024',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Remove 1 Animal from any card and add it to this card.', function (eb) {
                        eb.animals(1).any.startAction.animals(1);
                    }).br;
                    b.vpText('1 VP per Animal on this card.');
                }),
                description: 'Requires 11% oxygen.',
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.animals(1, 1),
            },
        }) || this;
        _this.resourceCount = 0;
        return _this;
    }
    Predators.prototype.getVictoryPoints = function () {
        return this.resourceCount;
    };
    Predators.prototype.play = function () {
        return undefined;
    };
    Predators.prototype.canAct = function (player) {
        if (player.game.isSoloMode())
            return true;
        return RemoveResourcesFromCard_1.RemoveResourcesFromCard.getAvailableTargetCards(player, ResourceType_1.ResourceType.ANIMAL).length > 0;
    };
    Predators.prototype.action = function (player) {
        var _this = this;
        player.game.defer(new RemoveResourcesFromCard_1.RemoveResourcesFromCard(player, ResourceType_1.ResourceType.ANIMAL));
        player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.ANIMAL, { filter: function (c) { return c.name === _this.name; } }));
        return undefined;
    };
    return Predators;
}(Card_1.Card));
exports.Predators = Predators;
//# sourceMappingURL=Predators.js.map